import { CountrySelectorFormsy } from 'app/components/CountrySelectorFormsy'
import { TextInput } from 'app/components/FormsyHelperComponent'
import PhoneNumberInputFormsy, {
  validatePhoneNumber,
} from 'app/components/PhoneNumberInputFormsy'
import { withoutPostcodeCountries } from 'libs/country'
import StyledStateSelectorFormsy from 'app/components/StyledStateSelectorFormsy'
import { getFullPhoneNumber, useCountryCode } from 'commons/phoneNumber'
import { isEmptyOrNil } from 'libs/empty'
import * as R from 'ramda'
import React from 'react'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'

import { RowInput, RowInputTwoColumns } from './PlanBillingFormHelper'

PlanBillingShippingForm.propTypes = {
  initialValue: PropTypes.object,
  formRef: PropTypes.object.isRequired,
}

export function PlanBillingShippingForm({ initialValue = {}, formRef }) {
  const { formatMessage } = useIntl()
  const { countryCode } = useCountryCode()
  return (
    <>
      <RowInputTwoColumns
        icon="account_circle"
        columnOne={
          <TextInput
            labelId="firstName.label"
            placeholderId="firstName.label"
            name="shippingFirstName"
            value={
              R.path(['shippingAddress', 'firstName'], initialValue) ||
              R.prop('shippingFirstName', initialValue)
            }
            inputProps={{
              'data-testid': 'shippingFirstNameInput',
            }}
            required
            maxLength={40}
            fullWidth
          />
        }
        columnTwo={
          <TextInput
            labelId="lastName.label"
            placeholderId="lastName.label"
            name="shippingLastName"
            value={
              R.path(['shippingAddress', 'lastName'], initialValue) ||
              R.prop('shippingLastName', initialValue)
            }
            inputProps={{
              'data-testid': 'shippingLastNameInput',
            }}
            required
            maxLength={40}
            fullWidth
          />
        }
      />
      <RowInput icon="home">
        <TextInput
          containerClassName="w-full"
          labelId="planAndBilling.billingDetails.form.address1.label"
          placeholderId="planAndBilling.billingDetails.form.address1.label"
          name="shippingAddress1"
          inputProps={{
            'data-testid': 'shippingAddress1Input',
          }}
          value={R.path(['shippingAddress', 'address1'], initialValue)}
          required
          maxLength={250}
          multiline
          fullWidth
        />
      </RowInput>
      <RowInput icon="home">
        <TextInput
          containerClassName="w-full"
          labelId="planAndBilling.billingDetails.form.address2.label"
          placeholderId="planAndBilling.billingDetails.form.address2.label"
          name="shippingAddress2"
          inputProps={{
            'data-testid': 'shippingAddress2Input',
          }}
          value={R.path(['shippingAddress', 'address2'], initialValue)}
          maxLength={250}
          multiline
          fullWidth
        />
      </RowInput>
      <RowInputTwoColumns
        icon="home"
        columnOne={
          <CountrySelectorFormsy
            label={formatMessage({
              id: 'planAndBilling.billingDetails.form.country.label',
            })}
            name="shippingCountry"
            value={R.path(['shippingAddress', 'country'], initialValue)}
            inputProps={{
              'data-testid': 'shippingCountryInput',
            }}
            FormControlProps={{
              required: true,
            }}
            required
          />
        }
        columnTwo={
          <StyledStateSelectorFormsy
            label={formatMessage({
              id: 'planAndBilling.billingDetails.form.state.label',
            })}
            name="shippingState"
            value={R.path(['shippingAddress', 'state'], initialValue)}
            inputProps={{
              'data-testid': 'shippingStateInput',
            }}
            FormControlProps={{
              required: true,
            }}
            country={R.compose(
              R.prop('shippingCountry'),
              R.ifElse(isEmptyOrNil, R.always({}), (r) => r.getModel()),
            )(R.prop('current', formRef))}
          />
        }
      />
      <RowInputTwoColumns
        icon="home"
        columnOne={
          <TextInput
            labelId="planAndBilling.billingDetails.form.city.label"
            placeholderId="planAndBilling.billingDetails.form.city.label"
            name="shippingCity"
            value={R.path(['shippingAddress', 'city'], initialValue)}
            inputProps={{
              'data-testid': 'shippingCityInput',
            }}
            maxLength={40}
            fullWidth
          />
        }
        columnTwo={
          <TextInput
            labelId="planAndBilling.billingDetails.form.zipCode.label"
            placeholderId="planAndBilling.billingDetails.form.zipCode.label"
            name="shippingZipCode"
            validationError={formatMessage({
              id: 'planAndBilling.billingDetails.form.zipCode.validation',
            })}
            validations={{
              matchRegexp: /^[_A-z0-9]*((-|\s)*[_A-z0-9])*$/,
            }}
            inputProps={{
              'data-testid': 'shippingZipCodeInput',
            }}
            value={R.path(['shippingAddress', 'zipCode'], initialValue)}
            required={R.compose(
              R.not,
              R.includes(R.__, R.pluck('code', withoutPostcodeCountries)),
              R.toUpper,
              R.propOr('', 'country'),
              R.ifElse(isEmptyOrNil, R.always({}), (r) => r.getModel()),
            )(R.prop('current', formRef))}
            maxLength={40}
            fullWidth
          />
        }
      />
      <RowInput icon="local_phone">
        <PhoneNumberInputFormsy
          value={R.ifElse(
            isEmptyOrNil,
            R.always(''),
            R.always(
              getFullPhoneNumber(
                R.path(['shippingAddress', 'countryCode'], initialValue),
                R.path(['shippingAddress', 'phoneNumber'], initialValue),
              ),
            ),
          )(R.path(['shippingAddress', 'phoneNumber'], initialValue))}
          name="shippingPhoneNumber"
          containerClassName="w-full"
          autoComplete="new-password"
          enableSearchField
          disableSearchIcon
          disableAreaCodes={true}
          label={formatMessage({
            id: 'phone.label',
          })}
          defaultCountry={countryCode}
          validations={{
            isPhoneNumber: validatePhoneNumber,
          }}
          validationErrors={{
            isPhoneNumber: formatMessage({
              id: 'memberForm.phoneNumberInvalid',
            }),
          }}
          inputExtraProps={{
            InputProps: {
              'data-testid': 'shippingPhoneNumberInput',
              endAdornment: null,
            },
          }}
          isScrollWhenFocus
        />
      </RowInput>
    </>
  )
}
